module.exports = __webpack_public_path__ + "img/Dart.fba47bf7.png";